import { ColumnFieldType } from '../enums/index';

export abstract class ColumnFieldTypeObject {
  FieldType: ColumnFieldType;
}
